/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDarkMenuItemExpandableItemLink } from "./d-theme-dark-menu-item-expandable-item-link";

export class DThemeDarkMenuSidedItemExpandableItemLink extends DThemeDarkMenuItemExpandableItemLink {}
